export const useSetTheme = (value = null) => new Promise((res, rej) => {

    if(typeof window === 'object')
    {
        localStorage.setItem('darktheme', `${value}`)
    }

})
